import storage from "~/services/storage"

const GUEST_ROUTES = [
  "login",
  "viedtema-smartFileSlug-ievads",
  "pirmsskola",
  "abonements",
]

export default defineNuxtRouteMiddleware((to, _from) => {
  if (useRuntimeConfig().public.appEnv !== "test") {
    if (!GUEST_ROUTES.includes(to.name?.toString() ?? "") && !storage.getAuthToken()) {
      const config = useRuntimeConfig()
      const configHost = new URL(config.public.landingDomainName)
      if (process.client && window.location.hostname !== configHost.hostname) {
        if (to.path === "/" || to.path === "/pirmsskola" || to.path === "/abonements") {
          return
        }
      }
      storage.set("after_auth_url", config.app.baseURL + to.fullPath)
      window.location.href = "/v2/login"
    }
  }
})
